import type { ReactElement } from 'react';

import iconMarkup from '@autop/ui/assets/logo/icon.svg';
import markMarkup from '@autop/ui/assets/logo/mark.svg';
import wordmarkMarkup from '@autop/ui/assets/logo/wordmark.svg';

import { cn } from '@/shared/lib/utils';

type LogoProps = {
  /** 래퍼에 적용된다. 크기는 여기서, 색은 text-* 와 --autop-logo-accent 로 준다. */
  className?: string;
};

/**
 * SVG 를 인라인 마크업으로 심는다.
 *
 * <img src="...svg"> 로 넣으면 currentColor 도 --autop-logo-accent 도 적용되지 않아
 * 색을 전혀 제어할 수 없다. 여기서 쓰는 문자열은 webpack asset/source 가
 * 빌드 타임에 인라인한 로컬 에셋이라 외부 입력이 섞일 여지가 없다.
 */
function InlineSvg({ markup, className }: { markup: string; className?: string }): ReactElement {
  return (
    <span
      className={cn('inline-block [&>svg]:block [&>svg]:h-auto [&>svg]:w-full', className)}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: 빌드 타임에 인라인되는 로컬 에셋이다
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
}

/** 주 로고. GNB·푸터·문서에 쓴다. 비율 524.11 : 184.84 */
export function Wordmark({ className }: LogoProps): ReactElement {
  return <InlineSvg markup={wordmarkMarkup} className={className} />;
}

/** 심볼 단독. 파비콘·아바타·좁은 자리. 비율 391.32 : 224.61 */
export function LogoMark({ className }: LogoProps): ReactElement {
  return <InlineSvg markup={markMarkup} className={className} />;
}

/** 정사각 앱 아이콘. 배경 면을 포함한다. */
export function LogoIcon({ className }: LogoProps): ReactElement {
  return <InlineSvg markup={iconMarkup} className={className} />;
}
